import React, { useEffect, useState } from 'react';
import { documentTagServices } from '../../../APIServices/documentTagServices';
import Pagination from '../../../hooks/Pagination';

function DeletedDocumentTagHistory({
  getDocumentTagData,
  setModalOpen,
  deletedPageNumber,
  setDeletedPageNumber,
  deletedItemsPerPage,
  setDeletedItemsPerPage,
  deleteDocumentTagList,
  deleteDocumentTagCount,
  getDeletedDocumentTagData,
}) {
  const [buttonLoader, setButtonLoader] = useState(false);
  const totalPage = Math.ceil(deleteDocumentTagCount / deletedItemsPerPage);

  const softDeleteRestoreDocumentTag = async (id) => {
    setButtonLoader(true);
    const data = await documentTagServices.softDeleteRestoreDocumentTag({
      id,
      type: 'restore',
    });
    if (data?.statusCode === 200) {
      getDocumentTagData();
      getDeletedDocumentTagData();
    }
    setButtonLoader(false);
  };

  const deleteDocumentTagData = async (id) => {
    setButtonLoader(true);
    const data = await documentTagServices.deleteDocumentTagData({ id });
    if (data?.statusCode === 200) {
      getDeletedDocumentTagData();
    }
    setButtonLoader(false);
  };

  useEffect(() => {
    getDeletedDocumentTagData();
  }, [deletedPageNumber, deletedItemsPerPage]);

  return (
    <div className="modal-backdrop" onClick={() => setModalOpen('')}>
      <div className="modal" style={{ maxWidth: 620 }} onClick={(e) => e.stopPropagation()}>
        <div className="modal-head">
          <div>
            <div className="modal-title">Deleted Document Tag List</div>
            <div className="xs muted">Restore and permanent delete document tags</div>
          </div>
          <button className="icon-btn" onClick={() => setModalOpen('')}>
            <i className="ti ti-x" />
          </button>
        </div>

        <div className="modal-body">
          <table className="tbl">
            <thead>
              <tr>
                <th>Document Tag</th>
                <th style={{ width: 140 }}>Actions</th>
              </tr>
            </thead>
            <tbody>
              {deleteDocumentTagList.map((item) => (
                <tr key={item._id}>
                  <td className="medium">{item.documentTag}</td>
                  <td>
                    <div className="flex gap-2">
                      <button
                        className="icon-btn"
                        title="Restore"
                        style={{ color: 'var(--info)' }}
                        onClick={() => softDeleteRestoreDocumentTag(item?._id)}
                        disabled={buttonLoader}
                      >
                        <i className="ti ti-rotate" />
                      </button>
                      <button
                        className="icon-btn"
                        title="Permanent Delete"
                        style={{ color: 'var(--danger)' }}
                        onClick={() => deleteDocumentTagData(item?._id)}
                        disabled={buttonLoader}
                      >
                        <i className="ti ti-trash-x" />
                      </button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>

          <Pagination
            itemsPerPage={deletedItemsPerPage}
            setItemsPerPage={setDeletedItemsPerPage}
            pageNumber={deletedPageNumber}
            setPageNumber={setDeletedPageNumber}
            totalPage={totalPage}
            totalItems={deleteDocumentTagCount}
          />
        </div>
      </div>
    </div>
  );
}

export default DeletedDocumentTagHistory;